import { selectEffectiveUserType } from "../../../../modules/context/contextSelectors"
import { useMatchEnvironment } from "../../../../modules/environment/envHooks"
import { UserType } from "../../../../modules/login/loginTypes"
import { useAppSelector } from "../../../../modules/store/storeHooks"

import { UNFINISHED_FEATURE_ENVIRONMENTS, USER_TYPES_WITHOUT_MERCHANTS_ENDPOINT } from "../constants/filterMenuConst"

/**
 * Whether the merchant accordion of the order drawers, and with it the whole subscriptions drawer,
 * has anything left to show. Outside the unfinished-feature environments the shops filter is hidden
 * for merchants and the merchant list is hidden for companies and support (no endpoint), so the
 * subscriptions pages hide their drawer button instead of opening an empty drawer.
 */
export function useHasOrderDrawerFilters(): boolean {
    const currentUserType = useAppSelector(selectEffectiveUserType)
    const isUnfinishedFilterEnvironment = useMatchEnvironment(UNFINISHED_FEATURE_ENVIRONMENTS)

    return (
        isUnfinishedFilterEnvironment ||
        (currentUserType !== undefined &&
            currentUserType !== UserType.MERCHANT &&
            !USER_TYPES_WITHOUT_MERCHANTS_ENDPOINT.includes(currentUserType))
    )
}
